import React from "react";

export interface CaptionVariant {
  id: string;
  text: string;
  characterCount: number;
}

interface CaptionVariantCardProps {
  variant: CaptionVariant;
  onSelect: () => void;
}

export const CaptionVariantCard: React.FC<CaptionVariantCardProps> = ({
  variant,
  onSelect,
}) => {
  return (
    <div className="border border-gray-200 rounded-lg p-4 hover:border-purple-300 transition-colors cursor-pointer bg-white shadow-xs">
      <div className="caption-text mb-4 text-gray-800 whitespace-pre-wrap">
        {variant.text.split("\n").map((line, i) => (
          <p key={i} className="mb-1">
            {line}
          </p>
        ))}
      </div>
      <div className="flex items-center justify-between mt-auto pt-3 border-t border-gray-100">
        <span className="text-xs text-gray-500">
          {variant.characterCount} characters
        </span>
        <button
          onClick={onSelect}
          className="px-4 py-1.5 text-sm bg-purple-600 text-white rounded-sm hover:bg-purple-700 transition-colors"
        >
          Select this caption
        </button>
      </div>
    </div>
  );
};
